module.exports = __webpack_public_path__ + "static/media/darkOverlay.632115b9.svg";